export const ROLES = [
  {
    value: "administrador",
    text: "Administrador",
    isAdmin: true,
  },
  {
    value: "coordinadorDesarrolloAcademico",
    text: "Coordinador de Desarrollo Académico",
    isAdmin: true,
  },
  {
    value: "coordinadorDirectorAcademico",
    text: "Coordinador / Director Académico",
    isAdmin: true,
  },
  {
    value: "docente",
    text: "Docente",
    isAdmin: false,
  },
  {
    value: "evaluador",
    text: "Evaluador",
    isAdmin: true,
  },
  {
    value: "externo",
    text: "Externo",
    isAdmin: true,
  },
];
